<template>
  <div id="suppliers" class="px-4">
    <surgery-list />
  </div>
</template>
<script>
import SurgeryList from "@/components/surgery_management/SurgeryList.vue";
export default {
  components: {
    SurgeryList
  }
};
</script>
